export enum UserRole {
  PREREGISTER = "Pre Registro",
}
